import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth.tsx';
import { Layout } from './components/Layout.tsx';
import { LoginPage } from './pages/Login.tsx';
import { OverviewPage } from './pages/Overview.tsx';
import { ActionsPage } from './pages/Actions.tsx';
import { CalendarPage } from './pages/Calendar.tsx';
import { MetricsPage } from './pages/Metrics.tsx';
import { CompetitorsPage } from './pages/Competitors.tsx';
import { NewsPage } from './pages/News.tsx';
import { AuditPage } from './pages/Audit.tsx';
import { UsersPage } from './pages/Users.tsx';

export function App() {
  const { user, loading, can } = useAuth();

  if (loading) {
    return (
      <div className="boot-screen">
        <span className="text-label text-muted">Carregando a central…</span>
      </div>
    );
  }

  if (!user) return <LoginPage />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<OverviewPage />} />
        <Route path="/acoes" element={<ActionsPage />} />
        <Route path="/calendario" element={<CalendarPage />} />
        <Route path="/metricas" element={<MetricsPage />} />
        <Route path="/concorrencia" element={<CompetitorsPage />} />
        <Route path="/noticias" element={<NewsPage />} />
        <Route path="/auditoria" element={<AuditPage />} />
        <Route
          path="/usuarios"
          element={can('superadmin') ? <UsersPage /> : <Navigate to="/" replace />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
